var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoNightmode24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_nightmode24x24",
    transform: "translate(-4 -1.982)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24226",
    "data-name": "Group 24226",
    transform: "translate(4 1.982)",
    fill: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "sleep-regime",
    d: "M14.787,8.646a.567.567,0,0,0-.619-.043,5.934,5.934,0,0,1-2.918.784A5.807,5.807,0,0,1,5.37,3.665,5.489,5.489,0,0,1,6.176.823a.529.529,0,0,0-.046-.6A.564.564,0,0,0,5.543.036,7.771,7.771,0,0,0,1.575,2.66,7.186,7.186,0,0,0,0,7.164a7.561,7.561,0,0,0,7.653,7.449,7.651,7.651,0,0,0,4.628-1.533,7.545,7.545,0,0,0,2.7-3.86.532.532,0,0,0-.191-.574Z",
    transform: "translate(0 3.387)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "clean",
    transform: "translate(7.61)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43172",
    "data-name": "Path 43172",
    d: "M228.852,227.76a1.851,1.851,0,0,1-1.31-.538,1.82,1.82,0,0,1-.542-1.3.244.244,0,0,0-.488,0,1.82,1.82,0,0,1-.542,1.3,1.851,1.851,0,0,1-1.31.538.244.244,0,1,0,0,.488,1.851,1.851,0,0,1,1.851,1.844.244.244,0,0,0,.488,0,1.851,1.851,0,0,1,1.851-1.844.244.244,0,1,0,0-.488Z",
    transform: "translate(-222.632 -221.519)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43173",
    "data-name": "Path 43173",
    d: "M3.341,143.392a1.3,1.3,0,0,1-1.3-1.3.244.244,0,1,0-.488,0,1.3,1.3,0,0,1-1.3,1.3.244.244,0,0,0,0,.488,1.3,1.3,0,0,1,1.3,1.3.244.244,0,1,0,.488,0,1.3,1.3,0,0,1,1.3-1.3.244.244,0,0,0,0-.488Z",
    transform: "translate(-.017 -141.837)"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoNightmode24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_nightmode24x24.fd9e2f5e8eefd063543fa138a11a0267.svg";